(() => {
  window.DarPrirodeQuizScriptLoaded = true;
  const focusableSelector =
    'button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])';

  const groupLabels = {
    stress: 'Stres i san',
    focus: 'Energija i fokus',
    immunity: 'Imunitet i otpornost',
    metabolism: 'Probava i metabolizam',
    circulation: 'Srce, krv i cirkulacija',
    joints: 'Bolovi i pokretljivost',
    beauty: 'Koža, kosa, nokti i oči',
    women: 'Žensko zdravlje',
    men: 'Muško zdravlje',
    respiratory: 'Pluća i sinusi',
    urinary: 'Mokraćni sistem',
    none: 'Bez dodatne potrebe'
  };

  const needGroups = {
    stress: ['stres i san'],
    focus: ['energija i fokus'],
    immunity: ['imunitet i otpornost'],
    metabolism: ['secer i metabolizam', 'probava i crijeva', 'jetra i detoks'],
    circulation: ['srce i cirkulacija', 'krv i zeljezo'],
    joints: ['bolovi i pokretljivost'],
    beauty: ['koza, kosa i nokti', 'oci i vid'],
    women: ['zensko zdravlje'],
    men: ['musko zdravlje'],
    respiratory: ['pluca i sinusi'],
    urinary: ['mokracni sistem']
  };

  const resultCopy = {
    stress: {
      title: 'Proizvodi za mirniji svakodnevni ritam',
      summary: 'Prikazujemo sve dostupne proizvode povezane sa stresom, snom i vašom eventualnom dodatnom potrebom.'
    },
    focus: {
      title: 'Proizvodi za energiju i fokus',
      summary: 'Prikazujemo sve dostupne proizvode povezane s dnevnom vitalnošću, fokusom i odabranom dodatnom potrebom.'
    },
    immunity: {
      title: 'Proizvodi za imunitet i otpornost',
      summary: 'Prikazujemo sve dostupne proizvode povezane sa svakodnevnom ili sezonskom rutinom imuniteta.'
    },
    metabolism: {
      title: 'Proizvodi za probavu i metabolizam',
      summary: 'Prikazujemo sve dostupne proizvode povezane s probavom, metabolizmom ili detoks rutinom.'
    },
    circulation: {
      title: 'Proizvodi za srce, krv i cirkulaciju',
      summary: 'Prikazujemo sve dostupne proizvode povezane s ovom potrebom i eventualnom dodatnom rutinom.'
    },
    joints: {
      title: 'Proizvodi za pokretljivost',
      summary: 'Prikazujemo sve dostupne proizvode povezane sa svakodnevnom rutinom pokretljivosti.'
    },
    beauty: {
      title: 'Proizvodi za kožu, kosu, nokte i oči',
      summary: 'Prikazujemo sve dostupne proizvode povezane s odabranom beauty i nutritivnom rutinom.'
    },
    women: {
      title: 'Proizvodi za žensku rutinu',
      summary: 'Prikazujemo sve dostupne proizvode povezane s odabranom ženskom svakodnevnom rutinom.'
    },
    men: {
      title: 'Proizvodi za mušku rutinu',
      summary: 'Prikazujemo sve dostupne proizvode povezane s odabranom muškom svakodnevnom rutinom.'
    },
    respiratory: {
      title: 'Proizvodi za pluća i sinuse',
      summary: 'Prikazujemo sve dostupne proizvode povezane s ovom potrebom i eventualnom dodatnom rutinom.'
    },
    urinary: {
      title: 'Proizvodi za mokraćni sistem',
      summary: 'Prikazujemo sve dostupne proizvode povezane s odabranom rutinom.'
    }
  };

  const priorityLabels = {
    precise: 'preciznije usmjereni proizvodi',
    coverage: 'proizvodi koji pokrivaju više potreba',
    balanced: 'balansiran pregled ponude',
    compare: 'šire poređenje alternativa'
  };

  const sortLabels = {
    match: 'najbolje poklapanje prvo',
    'price-low': 'povoljniji proizvodi prvo',
    'price-high': 'viša cijena prvo',
    name: 'naziv proizvoda A–Z'
  };

  const experienceLabels = {
    beginner: 'prvi put birate CBD',
    some: 'imate prethodno iskustvo',
    experienced: 'imate više iskustva',
    unsure: 'niste sigurni u početni pravac'
  };

  const strengthLabels = {
    low: 'blaže koncentracije',
    medium: 'srednja koncentracija',
    high: 'koncentrisanije opcije',
    unsure: 'neutralan pregled koncentracija'
  };

  const normalizeText = (value) =>
    String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();

  const parseNeeds = (raw) => {
    if (!raw) return [];

    let value = raw;

    try {
      value = JSON.parse(raw);
    } catch (_) {}

    if (Array.isArray(value)) {
      return value.map(normalizeText).filter(Boolean);
    }

    return String(value)
      .split(/\n|\r|\|/)
      .map(normalizeText)
      .filter(Boolean);
  };

  const matchesGroup = (needs, group) => {
    if (!group || group === 'none') return false;
    const targets = needGroups[group] || [];

    return needs.some((need) =>
      targets.some((target) => need.includes(target) || target.includes(need))
    );
  };

  const getQuizForOpener = (opener) => {
    const controlledId = opener.getAttribute('aria-controls');
    if (controlledId) return document.getElementById(controlledId);

    const section = opener.closest('[data-dp-hero-root]');
    if (section) {
      const sectionId = section.id.replace('DarPrirodeHero-', '');
      return document.getElementById(`DarPrirodeQuiz-${sectionId}`);
    }

    return document.querySelector('[data-dp-quiz]');
  };

  const createController = (quiz) => {
    if (!quiz || quiz._dpQuizController) return quiz?._dpQuizController;

    const steps = [...quiz.querySelectorAll('[data-dp-quiz-step]')];
    const result = quiz.querySelector('[data-dp-quiz-result]');
    const progressWrap = quiz.querySelector('[data-dp-quiz-progress-wrap]');
    const progress = quiz.querySelector('.dp-quiz__progress');
    const progressBar = quiz.querySelector('[data-dp-quiz-progress-bar]');
    const progressLabel = quiz.querySelector('[data-dp-quiz-progress-label]');
    const progressPercent = quiz.querySelector('[data-dp-quiz-progress-percent]');
    const productsContainer = quiz.querySelector('[data-dp-result-products]');
    const emptyState = quiz.querySelector('[data-dp-result-empty]');
    const addAllButton = quiz.querySelector('[data-dp-add-results]');
    const selectionBar = quiz.querySelector('[data-dp-selection-bar]');
    const selectedCount = quiz.querySelector('[data-dp-selected-count]');
    const selectedTotal = quiz.querySelector('[data-dp-selected-total]');
    const status = quiz.querySelector('[data-dp-quiz-status]');
    const context = quiz.querySelector('[data-dp-quiz-context]');
    const currency = quiz.dataset.currency || 'BAM';

    let answers = {};
    let mode = 'all';
    let activeSteps = [1, 2, 3, 4, 5];
    let currentIndex = 0;
    let previousFocus = null;
    let currentPrefill = '';

    const formatMoney = (cents) => {
      try {
        return new Intl.NumberFormat('bs-BA', {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(Number(cents || 0) / 100);
      } catch (_) {
        return `${(Number(cents || 0) / 100).toFixed(2).replace('.', ',')} KM`;
      }
    };

    const calculateActiveSteps = () => {
      if (mode === 'cbd') {
        activeSteps = [1, 2, 4];
      } else if (mode === 'supplements') {
        activeSteps = [1, 2, 3, 4];
        answers.cbd = 'no';
      } else {
        activeSteps = [1, 2, 3, 4, 5];
      }
    };

    const toggleModeSets = () => {
      const targetMode = mode === 'cbd' ? 'cbd' : 'general';

      quiz.querySelectorAll('[data-dp-mode-set]').forEach((set) => {
        set.hidden = set.dataset.dpModeSet !== targetMode;
      });
    };

    const getVisibleSet = (step) => {
      const sets = [...step.querySelectorAll('[data-dp-mode-set]')];
      if (!sets.length) return step;
      return sets.find((set) => !set.hidden) || null;
    };

    const getVisibleQuestion = (step) => {
      const set = getVisibleSet(step);
      return set?.querySelector('[data-dp-answer]')?.dataset.question || '';
    };

    const getVisibleAnswers = (step) => {
      const set = getVisibleSet(step);
      return set ? [...set.querySelectorAll('[data-dp-answer]')] : [];
    };

    const updateSecondaryChoices = () => {
      if (mode === 'cbd') return;

      quiz.querySelectorAll('[data-question="secondary"]').forEach((button) => {
        const sameAsPrimary =
          button.dataset.value !== 'none' &&
          button.dataset.value === answers.primary;

        button.hidden = sameAsPrimary;
        button.disabled = sameAsPrimary;

        if (sameAsPrimary && button.classList.contains('is-selected')) {
          button.classList.remove('is-selected');
          button.setAttribute('aria-pressed', 'false');
          delete answers.secondary;
        }
      });
    };

    const updateProgress = () => {
      const total = activeSteps.length;
      const position = Math.max(1, currentIndex + 1);
      const percent = Math.round((position / total) * 100);

      progressBar.style.width = `${percent}%`;
      progressLabel.textContent = `Korak ${position} od ${total}`;
      progressPercent.textContent = `${percent}%`;
      progress.setAttribute('aria-valuemax', String(total));
      progress.setAttribute('aria-valuenow', String(position));
    };

    const showCurrentStep = () => {
      calculateActiveSteps();
      toggleModeSets();
      updateSecondaryChoices();

      currentIndex = Math.max(0, Math.min(currentIndex, activeSteps.length - 1));
      const stepNumber = activeSteps[currentIndex];

      result.hidden = true;
      progressWrap.hidden = false;
      if (selectionBar) selectionBar.hidden = true;

      steps.forEach((step) => {
        const active = Number(step.dataset.dpQuizStep) === stepNumber;
        step.hidden = !active;
        step.classList.toggle('is-active', active);
      });

      updateProgress();

      const activeStep = steps.find(
        (step) => Number(step.dataset.dpQuizStep) === stepNumber
      );

      if (!activeStep) return;

      const question = getVisibleQuestion(activeStep);
      const selected = question
        ? activeStep.querySelector(`[data-question="${question}"].is-selected`)
        : null;
      const next = activeStep.querySelector(
        '[data-dp-next], [data-dp-result-trigger]'
      );

      if (next) {
        next.disabled = !selected;

        const isFinalStep = currentIndex === activeSteps.length - 1;
        const nextCopy = next.querySelector('[data-dp-next-copy]');

        if (nextCopy) {
          nextCopy.textContent = isFinalStep ? 'Prikaži proizvode' : 'Nastavi';
        }

        next.classList.toggle('dp-quiz__next--result', isFinalStep);
      }

      (selected || getVisibleAnswers(activeStep)[0])?.focus({
        preventScroll: true
      });
    };

    const selectAnswer = (button, question, value) => {
      const step = button.closest('[data-dp-quiz-step]');

      step.querySelectorAll(`[data-question="${question}"]`).forEach((candidate) => {
        candidate.classList.remove('is-selected');
        candidate.setAttribute('aria-pressed', 'false');
      });

      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
      answers[question] = value;
    };

    const updateContext = () => {
      if (!context) return;

      if (mode === 'cbd') {
        context.hidden = false;
        context.textContent = 'Otvoren je poseban CBD vodič';
        return;
      }

      if (currentPrefill && groupLabels[currentPrefill]) {
        context.hidden = false;
        context.textContent = `Već ste odabrali: ${groupLabels[currentPrefill]}`;
        return;
      }

      context.hidden = true;
      context.textContent = '';
    };

    const updateSelectionSummary = () => {
      const selectedCards = [
        ...productsContainer.querySelectorAll('[data-dp-quiz-product]')
      ].filter((card) => card.querySelector('[data-dp-product-select]')?.checked);

      const count = selectedCards.length;
      const total = selectedCards.reduce(
        (sum, card) => sum + Number(card.dataset.price || 0),
        0
      );

      selectedCards.forEach((card) => card.classList.add('is-selected'));
      productsContainer
        .querySelectorAll('[data-dp-quiz-product]')
        .forEach((card) => {
          const checked = card.querySelector('[data-dp-product-select]')?.checked;
          card.classList.toggle('is-selected', Boolean(checked));
        });

      if (selectedCount) {
        selectedCount.textContent = `${count} ${count === 1 ? 'proizvod' : 'proizvoda'}`;
      }

      if (selectedTotal) selectedTotal.textContent = formatMoney(total);
      if (addAllButton) addAllButton.disabled = count === 0;
    };

    const reset = ({ quizMode = 'all', prefill = '' } = {}) => {
      answers = {};
      mode = ['all', 'supplements', 'cbd'].includes(quizMode)
        ? quizMode
        : 'all';
      currentPrefill = prefill || '';
      currentIndex = 0;

      quiz.querySelectorAll('[data-dp-answer]').forEach((button) => {
        button.classList.remove('is-selected');
        button.setAttribute('aria-pressed', 'false');
        button.hidden = false;
        button.disabled = false;
      });

      quiz.querySelectorAll('[data-dp-next], [data-dp-result-trigger]').forEach((button) => {
        button.disabled = true;
      });

      productsContainer.innerHTML = '';
      emptyState.hidden = true;
      if (selectionBar) selectionBar.hidden = true;
      addAllButton.disabled = true;
      addAllButton.textContent = 'Dodaj odabrano u korpu';
      if (selectedCount) selectedCount.textContent = '0 proizvoda';
      if (selectedTotal) selectedTotal.textContent = formatMoney(0);
      status.textContent = '';

      calculateActiveSteps();
      toggleModeSets();
      updateContext();

      if (prefill && mode !== 'cbd') {
        const prefillButton = quiz.querySelector(
          `[data-question="primary"][data-value="${CSS.escape(prefill)}"]`
        );

        if (prefillButton) {
          selectAnswer(prefillButton, 'primary', prefill);
          currentIndex = activeSteps.indexOf(2);
          if (currentIndex < 0) currentIndex = 0;
        }
      }

      showCurrentStep();
    };

    const open = ({ opener = null, quizMode = 'all', prefill = '' } = {}) => {
      previousFocus = opener || document.activeElement;
      reset({ quizMode, prefill });

      quiz.hidden = false;
      quiz.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('dp-quiz-lock');

      window.requestAnimationFrame(() => {
        quiz.classList.add('is-open');
        quiz.querySelector('[data-dp-quiz-close]')?.focus({
          preventScroll: true
        });
      });
    };

    const close = (restoreFocus = true) => {
      quiz.classList.remove('is-open');
      quiz.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('dp-quiz-lock');

      window.setTimeout(() => {
        quiz.hidden = true;
      }, 320);

      if (restoreFocus) previousFocus?.focus?.();
    };

    const scoreGeneralCard = (card) => {
      if (card.dataset.available !== 'true') return null;

      const isCbd = card.dataset.isCbd === 'true';
      const needs = parseNeeds(card.dataset.needsJson || '');

      if (mode === 'supplements' && isCbd) return null;
      if (mode === 'all' && answers.cbd === 'no' && isCbd) return null;

      const primaryMatch = matchesGroup(needs, answers.primary);
      const hasSecondary = answers.secondary && answers.secondary !== 'none';
      const secondaryMatch = hasSecondary && matchesGroup(needs, answers.secondary);

      if (!primaryMatch && !secondaryMatch) return null;

      let matchType = 'secondary';
      let matchRank = 1;

      if (primaryMatch && secondaryMatch) {
        matchType = 'both';
        matchRank = 3;
      } else if (primaryMatch) {
        matchType = 'primary';
        matchRank = 2;
      }

      let score = matchRank * 100;

      if (answers.priority === 'precise') {
        score += Math.max(0, 24 - Math.max(1, needs.length) * 3);
      } else if (answers.priority === 'coverage') {
        score += Math.min(needs.length, 8) * 3;
        if (matchType === 'both') score += 18;
      } else if (answers.priority === 'balanced') {
        score += 8;
      } else if (answers.priority === 'compare') {
        score += 2;
      }

      if (mode === 'all' && answers.cbd === 'prefer' && isCbd) score += 20;
      if (mode === 'all' && answers.cbd === 'allow' && isCbd) score += 1;

      return {
        card,
        score,
        matchType,
        matchRank,
        primaryMatch,
        secondaryMatch,
        isCbd,
        needs,
        price: Number(card.dataset.price || 0),
        title: normalizeText(card.dataset.title || ''),
        order: Number(card.dataset.order || 999)
      };
    };

    const scoreCbdCard = (card) => {
      if (card.dataset.available !== 'true') return null;
      if (card.dataset.isCbd !== 'true') return null;

      const strength = card.dataset.cbdStrength || 'unknown';
      let score = 100;

      const experienceBoosts = {
        beginner: { low: 22, medium: 8, high: -10, unknown: 2 },
        some: { low: 8, medium: 20, high: 7, unknown: 3 },
        experienced: { low: 3, medium: 10, high: 21, unknown: 4 },
        unsure: { low: 10, medium: 12, high: 2, unknown: 5 }
      };

      score += experienceBoosts[answers.experience]?.[strength] || 0;

      if (answers.strength && answers.strength !== 'unsure') {
        if (strength === answers.strength) score += 28;
        else if (strength !== 'unknown') score -= 4;
      }

      return {
        card,
        score,
        matchType: 'cbd',
        matchRank: 1,
        primaryMatch: false,
        secondaryMatch: false,
        isCbd: true,
        needs: [],
        price: Number(card.dataset.price || 0),
        title: normalizeText(card.dataset.title || ''),
        order: Number(card.dataset.order || 999)
      };
    };

    const sortItems = (items) => {
      const sort = answers.sort || 'match';

      return [...items].sort((a, b) => {
        if (sort === 'price-low' && a.price !== b.price) return a.price - b.price;
        if (sort === 'price-high' && a.price !== b.price) return b.price - a.price;
        if (sort === 'name' && a.title !== b.title) return a.title.localeCompare(b.title, 'bs');
        if (a.score !== b.score) return b.score - a.score;
        if (a.title !== b.title) return a.title.localeCompare(b.title, 'bs');
        return a.order - b.order;
      });
    };

    const buildProductClone = (item) => {
      const { card, matchType, isCbd } = item;
      const clone = card.cloneNode(true);
      clone.removeAttribute('hidden');
      clone.removeAttribute('aria-hidden');

      const checkbox = clone.querySelector('[data-dp-product-select]');
      if (checkbox) checkbox.checked = false;

      const badge = clone.querySelector('.dp-quiz-product__badge');
      const reason = clone.querySelector('[data-dp-product-reason]');

      if (badge) {
        if (mode === 'cbd') badge.textContent = 'CBD opcija';
        else if (matchType === 'both') badge.textContent = 'Obje odabrane potrebe';
        else if (matchType === 'primary') badge.textContent = 'Glavna potreba';
        else badge.textContent = 'Dodatna potreba';
      }

      if (reason) {
        if (mode === 'cbd') {
          reason.textContent =
            'Povezan je s iskustvom i grupom koncentracija koju ste odabrali.';
        } else if (matchType === 'both') {
          reason.textContent =
            `Poklapa se s potrebama „${groupLabels[answers.primary]}” i „${groupLabels[answers.secondary]}”.`;
        } else if (matchType === 'primary') {
          reason.textContent =
            `Povezan je s vašom glavnom potrebom: ${groupLabels[answers.primary]}.`;
        } else {
          reason.textContent =
            `Povezan je s dodatnom potrebom: ${groupLabels[answers.secondary]}.`;
        }

        if (isCbd && mode !== 'cbd') {
          reason.textContent += ' CBD je prikazan jer ste ga dozvolili u rezultatima.';
        }
      }

      return clone;
    };

    const appendGroup = (title, subtitle, items) => {
      if (!items.length) return;

      const section = document.createElement('section');
      section.className = 'dp-quiz__product-group';

      const heading = document.createElement('div');
      heading.className = 'dp-quiz__product-group-head';
      heading.innerHTML = `
        <div>
          <span>${title}</span>
          <small>${subtitle}</small>
        </div>
        <strong>${items.length}</strong>
      `;

      const grid = document.createElement('div');
      grid.className = 'dp-quiz__product-grid';

      sortItems(items).forEach((item) => {
        grid.appendChild(buildProductClone(item));
      });

      section.append(heading, grid);
      productsContainer.appendChild(section);
    };

    const renderResults = () => {
      const catalogCards = [
        ...quiz.querySelectorAll('.dp-quiz__catalog [data-dp-quiz-product]')
      ];

      const scored = catalogCards
        .map(mode === 'cbd' ? scoreCbdCard : scoreGeneralCard)
        .filter(Boolean);

      const title = quiz.querySelector('[data-dp-result-title]');
      const summary = quiz.querySelector('[data-dp-result-summary]');
      const combination = quiz.querySelector('[data-dp-result-combination]');

      productsContainer.innerHTML = '';

      if (mode === 'cbd') {
        const cbdItems = sortItems(scored);

        title.textContent = 'CBD proizvodi prema vašim odgovorima';
        summary.textContent =
          'Prikazujemo sve dostupne CBD proizvode. Kviz ih samo poređuje, a konačni izbor ostaje vaš.';
        combination.textContent =
          `Odabrali ste: ${experienceLabels[answers.experience] || 'neutralan pravac'} · ` +
          `${strengthLabels[answers.strength] || 'pregled dostupnih koncentracija'} · ` +
          `${sortLabels[answers.sort] || 'najbolje poklapanje prvo'} · ` +
          `${cbdItems.length} ${cbdItems.length === 1 ? 'proizvod' : 'proizvoda'}.`;

        appendGroup(
          'CBD proizvodi za pregled',
          'Svi dostupni proizvodi su prikazani; redoslijed prati vaše odgovore.',
          cbdItems
        );
      } else {
        const copy = resultCopy[answers.primary] || resultCopy.stress;
        const hasSecondary = answers.secondary && answers.secondary !== 'none';
        const both = scored.filter((item) => item.matchType === 'both');
        const primary = scored.filter((item) => item.matchType === 'primary');
        const secondary = scored.filter((item) => item.matchType === 'secondary');
        const secondaryText = hasSecondary
          ? ` · Dodatno: ${groupLabels[answers.secondary]}`
          : '';

        title.textContent = copy.title;
        summary.textContent =
          `${copy.summary} Kviz ne nameće jedan proizvod — sami označite šta želite detaljnije pregledati ili dodati u korpu.`;
        combination.textContent =
          `Glavna potreba: ${groupLabels[answers.primary]}${secondaryText} · ` +
          `Prikaz: ${priorityLabels[answers.priority] || 'balansiran pregled ponude'} · ` +
          `Redoslijed: ${sortLabels[answers.sort] || 'najbolje poklapanje prvo'} · ` +
          `${scored.length} ${scored.length === 1 ? 'povezan proizvod' : 'povezanih proizvoda'}.`;

        if (hasSecondary) {
          appendGroup(
            'Odgovaraju objema potrebama',
            'Ovi proizvodi su povezani i s glavnom i s dodatnom potrebom.',
            both
          );
        }

        appendGroup(
          `Za glavnu potrebu: ${groupLabels[answers.primary]}`,
          'Svi dostupni proizvodi povezani s vašom glavnom potrebom.',
          primary
        );

        if (hasSecondary) {
          appendGroup(
            `Za dodatnu potrebu: ${groupLabels[answers.secondary]}`,
            'Dodatne opcije povezane s drugom odabranom potrebom.',
            secondary
          );
        }
      }

      const hasProducts = scored.length > 0;
      emptyState.hidden = hasProducts;
      if (selectionBar) selectionBar.hidden = !hasProducts;
      updateSelectionSummary();

      steps.forEach((step) => {
        step.hidden = true;
      });

      progressWrap.hidden = true;
      result.hidden = false;

      result.scrollIntoView({
        block: 'start',
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'auto'
          : 'smooth'
      });

      result.querySelector('h3')?.focus?.({ preventScroll: true });
    };

    const handleAnswer = (answer) => {
      const question = answer.dataset.question;
      selectAnswer(answer, question, answer.dataset.value);

      if (question === 'primary') updateSecondaryChoices();

      const step = answer.closest('[data-dp-quiz-step]');
      const next = step.querySelector(
        '[data-dp-next], [data-dp-result-trigger]'
      );

      if (next) next.disabled = false;
    };

    quiz.addEventListener('change', (event) => {
      if (event.target.matches('[data-dp-product-select]')) {
        updateSelectionSummary();
      }
    });

    quiz.addEventListener('click', async (event) => {
      const answer = event.target.closest('[data-dp-answer]');
      if (answer) {
        handleAnswer(answer);
        return;
      }

      if (event.target.closest('[data-dp-quiz-close]')) {
        close();
        return;
      }

      if (event.target.closest('[data-dp-back]')) {
        currentIndex -= 1;
        showCurrentStep();
        return;
      }

      if (event.target.closest('[data-dp-result-trigger]')) {
        renderResults();
        return;
      }

      if (event.target.closest('[data-dp-next]')) {
        if (currentIndex >= activeSteps.length - 1) {
          renderResults();
        } else {
          currentIndex += 1;
          showCurrentStep();
        }
        return;
      }

      if (event.target.closest('[data-dp-quiz-restart]')) {
        reset({ quizMode: mode });
        return;
      }

      const productCard = event.target.closest('[data-dp-quiz-product]');
      if (
        productCard &&
        !event.target.closest('a, input, label, button')
      ) {
        const checkbox = productCard.querySelector('[data-dp-product-select]');
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          checkbox.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }

      if (event.target.closest('[data-dp-add-results]')) {
        const selectedCards = [
          ...productsContainer.querySelectorAll('[data-dp-quiz-product]')
        ].filter(
          (card) => card.querySelector('[data-dp-product-select]')?.checked
        );

        const items = selectedCards
          .map((card) => ({
            id: Number(card.dataset.variantId || 0),
            quantity: 1
          }))
          .filter((item) => item.id);

        if (!items.length) {
          status.textContent = 'Odaberite najmanje jedan proizvod.';
          return;
        }

        addAllButton.disabled = true;
        addAllButton.textContent = 'Dodajem proizvode...';
        status.textContent = '';

        try {
          if (!window.DarPrirodeCart) {
            throw new Error('Sistem korpe nije učitan.');
          }

          await window.DarPrirodeCart.addItems(items, 'dar-prirode-quiz');

          addAllButton.textContent = 'Dodano ✓';
          status.textContent = 'Odabrani proizvodi su dodani u korpu.';

          window.setTimeout(() => {
            close(false);
            window.DarPrirodeCart.openDrawer();
          }, 520);
        } catch (error) {
          addAllButton.disabled = false;
          addAllButton.textContent = 'Dodaj odabrano u korpu';
          status.textContent =
            error?.message || 'Došlo je do greške. Pokušajte ponovo.';
        }
      }
    });

    quiz.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        close();
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = [...quiz.querySelectorAll(focusableSelector)].filter(
        (node) => !node.closest('[hidden]') && node.offsetParent !== null
      );

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    const controller = { open, close, reset };
    quiz._dpQuizController = controller;
    return controller;
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dp-quiz-open]');
    if (!opener) return;

    event.preventDefault();

    const quiz = getQuizForOpener(opener);
    const controller = createController(quiz);

    controller?.open({
      opener,
      quizMode: opener.dataset.quizMode || 'all',
      prefill: opener.dataset.quizPrefill || ''
    });
  });

  document.addEventListener('dp:quiz:open', (event) => {
    const sectionId = event.detail?.sectionId || '';
    const quiz =
      document.getElementById(`DarPrirodeQuiz-${sectionId}`) ||
      document.querySelector('[data-dp-quiz]');

    const controller = createController(quiz);

    controller?.open({
      opener: event.detail?.opener || null,
      quizMode: event.detail?.mode || 'all',
      prefill: event.detail?.prefill || ''
    });
  });

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-dp-quiz]').forEach(createController);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), {
      once: true
    });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAll(event.target);
  });
})();
